import { createSlice } from "@reduxjs/toolkit";
import { getvendorsList,updateVendorStatus, getVendorProductsList } from "./ThunkActions";
import { iVendorsState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: iVendorsState = {
  isLoading: false,
  vendorsList: [],
  errorMessage: null,
};

export const vendorsSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetEmployeeState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getvendorsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getvendorsList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.vendorsList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getvendorsList.rejected, (state) => {
        state.errorMessage = "Failed to fetch vendors list";
        state.isLoading = false;
      })
      .addCase(updateVendorStatus.fulfilled, (state, action) => {
        const { data } = action.payload || {};
        if (data?.data?.id) {
          const updatedVendor = state.vendorsList.find(v => v.id === data.data.id);
          if (updatedVendor) {
            updatedVendor.status = data.data.status;
          }
        }
      })
       .addCase(getVendorProductsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVendorProductsList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.vendorsList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getVendorProductsList.rejected, (state) => {
        state.errorMessage = "Failed to fetch vendor products list";
        state.isLoading = false;
      })
},
});
export const { resetEmployeeState: resetVendorsState } = vendorsSlice.actions;
export default vendorsSlice.reducer;

